import { useCallback, useMemo } from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getMessage } from '@gef-ui/localization/messages';
import Fire from '@gef-ui/material-icons/Fire';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { getLeadsInProgress } from 'features/views/dashboard/todaysUrgencies/selectors';
import { quickFilter } from 'features/views/marketPlace/constants';

import UrgencyTemplate from './UrgencyTemplate';

export const LeadsInProgress = () => {
	const navigate = useNavigate();

	const leadsInProgress = useSelector(getLeadsInProgress);
	const hasLeadsInProgress = leadsInProgress > 0;

	const linkText = useMemo(() => {
		return (
			!isNilOrEmpty(leadsInProgress) && getMessage('dashboard:todaysUrgencies.lead', { count: leadsInProgress })
		);
	}, [leadsInProgress]);

	const handleRedirect = useCallback(() => {
		navigate({
			pathname: '/market-place',
			search: `quickFilter=${quickFilter.IN_PROGRESS}`,
		});
	}, [navigate]);

	const leadsIcon = <Fire sx={{ color: 'orange', cursor: 'default' }} />;

	return (
		hasLeadsInProgress && (
			<ComponentLoader fetchStorePath={fetch.constants.urls.leadsInProgress}>
				<UrgencyTemplate icon={leadsIcon}>
					<Typography variant="body2">{getMessage('dashboard:todaysUrgencies.leadsInProgress')}</Typography>
					<Link underline="none" onClick={handleRedirect} sx={{ cursor: 'pointer', fontSize: 14 }}>
						{linkText}
					</Link>
				</UrgencyTemplate>
			</ComponentLoader>
		)
	);
};

export default LeadsInProgress;
